<template>
  <div ref="wrapEl" class="qr-code-label d-inline-block">
    <QrcodeVue :value="value || ''" :size="size" level="M" render-as="canvas" />
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'QrCodeLabel',
  components: { QrcodeVue },

  props: {
    // The exact URL encoded in the QR — must match what the "الرابط" column
    // shows and what a scanner reads (see BarcodeScanner.vue's URL parsing).
    value: { type: String, required: true },
    size: { type: Number, default: 100 },
    filename: { type: String, default: 'qr-code.png' },
  },

  methods: {
    downloadPng(filename) {
      const canvas = this.$refs.wrapEl?.querySelector('canvas');
      if (!canvas) return;

      const link = document.createElement('a');
      link.download = filename || this.filename;
      link.href = canvas.toDataURL('image/png');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
.qr-code-label canvas {
  display: block;
  max-width: 100%;
  height: auto;
}
</style>
